// extracted by mini-css-extract-plugin
module.exports = {"triangleClipPath":"marker_triangleClipPath___LI3x"};